module.exports = __webpack_public_path__ + "static/media/camping_tent.6999a514.webp";